<template>
  <div class="app-container">
    <!-- 搜索栏 -->
    <el-form :model="queryParams" ref="queryForm" :inline="true" size="small">
      <el-form-item label="操作人员" prop="operName">
        <el-input v-model="queryParams.operName" placeholder="请输入操作人员" clearable @keyup.enter.native="getList"/>
      </el-form-item>
      <el-form-item label="操作模块" prop="operModel">
        <el-select v-model="queryParams.operModel" placeholder="请选择模块" clearable style="width: 150px;">
          <el-option label="用户登录" value="用户登录"/>
          <el-option label="工单管理" value="工单管理"/>
          <el-option label="报修管理" value="报修管理"/>
          <el-option label="费用管理" value="费用管理"/>
          <el-option label="其他操作" value="其他操作"/>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
        <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- 表格 -->
    <el-table v-loading="loading" :data="logList" border stripe>
      <el-table-column label="操作时间" prop="operTime" width="180" align="center"/>
      <el-table-column label="操作人员" prop="operName" width="120" align="center"/>
      <el-table-column label="操作模块" prop="operModel" width="120" align="center"/>
      <el-table-column label="请求方法" prop="method" min-width="200" show-overflow-tooltip/>
      <el-table-column label="耗时 (ms)" prop="costTime" width="100" align="center"/>
      <el-table-column label="状态" width="80" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status == 0 ? 'success' : 'danger'" size="mini">
            {{ scope.row.status == 0 ? '成功' : '失败' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="错误信息" prop="errorMsg" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.status != 0" style="color: red;">{{ scope.row.errorMsg }}</span>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      style="margin-top: 20px; text-align: right;"
      :total="total"
      :page-size="queryParams.row"
      :current-page="queryParams.page"
      layout="total, prev, pager, next"
      @current-change="handlePageChange"
    />
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'OperLog',
  data() {
    return {
      loading: false,
      logList: [],
      total: 0,
      queryParams: { page: 1, row: 15, operName: '', operModel: '' }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      request({
        url: '/log.listSysOperLog',
        method: 'post',
        data: this.queryParams
      }).then(res => {
        this.loading = false
        if (res.data) {
          this.logList = res.data.data || []
          this.total = res.data.total || 0
        }
      }).catch(() => {
        this.loading = false
      })
    },
    handlePageChange(val) {
      this.queryParams.page = val
      this.getList()
    },
    resetQuery() {
      this.queryParams.operName = ''
      this.queryParams.operModel = ''
      this.queryParams.page = 1
      this.getList()
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
}
</style>
